import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { Button } from "@repo/ui/components/Base/Button";

interface DeleteConfirmationProps {
  open: boolean;
  setOpen: (arg: boolean) => void;
  onConfirm: () => void;
}
export function DeleteConfirmation({
  open,
  setOpen,
  onConfirm,
}: DeleteConfirmationProps) {
  const handleOpenChange = () => setOpen(!open);

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Deleting this team member will revoke all of their access to this team
          and remove them from any future agendas. Do you want to delete this
          user?
        </DialogDescription>
        <DialogFooter>
          <Button onClick={handleOpenChange} variant="destructive">
            Cancel
          </Button>
          <Button onClick={() => handleConfirm()}>Confirm</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
